import axiosInstance from '../../../config/axiosInstance';
const JobNotificationService = {
    async GetAllJobNotifications(redirectCallback, IssueID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/GetJobNotification?IssueID=${IssueID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteJobNotifications(ID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Job/DeleteJobNotification?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async UnmarkJobNotification(ID, redirectCallback) {
        try {                
            const response = await axiosInstance.get(`/Job/UnmarkJobNotification?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default JobNotificationService;